var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/schema";
/** Page request helper **/
const _deletePage = fetcher.path("/api/pages/{id}").method("delete").create();
export function deletePage(itemId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield _deletePage({
            id: itemId,
        });
        return data;
    });
}
const _updateTags = fetcher.path("/api/tags").method("put").create();
export function updateTags(itemId, itemClass, itemTags) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield _updateTags({
            item_id: itemId,
            item_class: itemClass,
            item_tags: itemTags,
        });
        return data;
    });
}
